"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.0001 20.5208C24.5874 20.5262 24.1931 20.6926 23.9012 20.9844C23.6093 21.2763 23.443 21.6706 23.4376 22.0833V33.6458C23.4376 34.0602 23.6022 34.4577 23.8952 34.7507C24.1883 35.0437 24.5857 35.2083 25.0001 35.2083C25.4145 35.2083 25.8119 35.0437 26.1049 34.7507C26.398 34.4577 26.5626 34.0602 26.5626 33.6458V22.0833C26.5572 21.6706 26.3908 21.2763 26.099 20.9844C25.8071 20.6926 25.4128 20.5262 25.0001 20.5208Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.0001 17.5833C25.3059 17.5833 25.6048 17.4923 25.8587 17.322C26.1127 17.1517 26.3102 16.9096 26.4263 16.6267C26.5423 16.3438 26.5716 16.0328 26.5104 15.7332C26.4492 15.4335 26.3003 15.1589 26.0826 14.9442C25.8649 14.7294 25.5883 14.5842 25.2879 14.5271C24.9875 14.47 24.6769 14.5035 24.3955 14.6234C24.1142 14.7433 23.8749 14.9441 23.708 15.2004C23.5412 15.4566 23.4543 15.7567 23.4584 16.0625C23.4639 16.4678 23.6287 16.8546 23.9173 17.1392C24.2058 17.4238 24.5948 17.5834 25.0001 17.5833Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.0001 4.16667C20.8796 4.16667 16.8517 5.38852 13.4257 7.67772C9.99969 9.96691 7.32943 13.2206 5.7526 17.0274C4.17577 20.8342 3.76321 25.0231 4.56706 29.0644C5.37092 33.1057 7.35511 36.8178 10.2687 39.7314C13.1823 42.645 16.8944 44.6292 20.9357 45.433C24.977 46.2369 29.1659 45.8243 32.9727 44.2475C36.7795 42.6707 40.0332 40.0004 42.3224 36.5744C44.6116 33.1484 45.8334 29.1204 45.8334 25C45.8334 22.2641 45.2946 19.555 44.2476 17.0274C43.2006 14.4998 41.666 12.2032 39.7315 10.2686C37.7969 8.33406 35.5003 6.79948 32.9727 5.75251C30.445 4.70554 27.736 4.16667 25.0001 4.16667ZM25.0001 42.625C21.5042 42.625 18.0869 41.5878 15.1807 39.6447C12.2745 37.7016 10.0102 34.94 8.67427 31.7094C7.33836 28.4788 6.99094 24.9245 7.67599 21.4964C8.36105 18.0683 10.0478 14.9204 12.5227 12.4514C14.9976 9.98231 18.1494 8.30302 21.5791 7.62606C25.0088 6.9491 28.5623 7.30491 31.7898 8.64845C35.0172 9.99199 37.7734 12.2629 39.7097 15.1736C41.6459 18.0843 42.675 21.5041 42.6668 25C42.6668 29.6855 40.8055 34.1791 37.4923 37.4922C34.1792 40.8054 29.6856 42.6667 25.0001 42.6667V42.625Z",
    fill: fill
  }));
};

exports["default"] = _default;